
import { Component, Vue, Watch } from 'vue-property-decorator';

import RetroactiveSalesInvoices from './RetroactiveSalesInvoices.vue';

import { sharedState } from '../../../../../framework/state';
import { getCustomerOptions } from '../../../../service/application_options_service';
import { postNextMonthlySalesInvoiceRequest } from '../../../../client/sales_invoice_client';
import { ValidationObserver } from 'vee-validate';
import DateField from '../../../../../framework/fields/DateField.vue';
import NumberField from '../../../../../framework/fields/NumberField.vue';
import TextField from '../../../../../framework/fields/TextField.vue';
import SelectField from '../../../../../framework/fields/SelectField.vue';
import { AddNextMonthlySalesInvoiceReq } from '../../../../../../common/application/model/api/AddNextMonthlySalesInvoiceReq';
import SwitchField from '../../../../../framework/fields/SwitchField.vue';
import { Customer } from '../../../../../../common/application/model/Customer';
import { getResource } from '../../../../../framework/client/resource';
import { ApplicationResource } from '../../../../../../common/application/enumeration/ApplicationResource';
import { successToast, errorToast } from '../../../../service/toast_service';

@Component({
    components: {
        DateField,
        NumberField,
        SwitchField,
        SelectField,
        TextField,
        ValidationObserver,
        RetroactiveSalesInvoices,
    },
})
export default class AddNextMonthlySalesInvoice extends Vue {
    // Properties

    // State
    shared = sharedState;
    local = {
        row: {
            addRetroactiveBilling: false,
            onlyRetroactiveBilling: false,
        } as AddNextMonthlySalesInvoiceReq,
        customerOptions: [] as { id: string | undefined; label: string }[],
        selectedCustomer: undefined as Customer | undefined,
    };

    // Functions
    async mounted() {
        this.local.customerOptions = await getCustomerOptions();

        this.local.row = {
            ...this.local.row,
            addRetroactiveBilling: false,
        };
    }

    @Watch('local.row.customerId')
    async selectedCustomerChanged(customerId: string) {
        if (!customerId) {
            return;
        }
        this.local.selectedCustomer = await getResource<Customer>(ApplicationResource.CUSTOMER, customerId);
    }

    async add() {
        try {
            const resp = await postNextMonthlySalesInvoiceRequest(this.local.row);
            successToast(this, 'message.salesInvoiceSaved');
            this.$router.push(`/sales-invoice/${resp.addedSalesInvoiceId}`);
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
